module.exports = __webpack_public_path__ + "media/images/vp/icon.filter.red-41b710b7c9024da77760b184855380ad.svg";